import tippy from 'tippy.js';
import moment from 'moment/moment';
import View from 'mixins/view';
import CommentsService from '@ui/comments/CommentService';

import ModerationModal from '@ui/comments/moderation-modal';
import BanModal from '@ui/comments/ban-modal';

const elements = {
    lastActivity: '.user-info__lastActivity',
    lastComment: '.user-info__lastComment',
    showAll: '.user-info__showAll',
};

export default class extends View {
    constructor(model) {
        super(model);
        this.setRootEl(
            $(`
                <div class="user-info js-Comment-Action-Box c-comments-main-box-list-element_actions shift-margin_2-bottom fn-hidden box-relative fn-withoutmode c-comments__actions-mod">
                    <span class="user-info__lastActivity link-naked text-color_appblue box-inline shift-margin_2-right"></span>
                    <span class="user-info__lastComment link-naked text-color_appblue box-inline shift-margin_2-right"></span>
                    <span class="user-info__showAll link-naked text-color_appblue box-inline shift-margin_2-right"></span>
                </div>
            `)
        );
    }
    buildReplyTrigger() {
        const replyTrigger = $(`
            <a href="#" class="link-naked text-color_appblue box-inline shift-margin_2-right user-actions">Odpowiedz</a>
        `);
        const captureReplyClick = event => {
            event.preventDefault();
            event.stopPropagation();

            this.parentNode.setReplyMode(this.model);
        };

        replyTrigger.on('click', captureReplyClick);

        return replyTrigger;
    }
    buildModerationWidgetTrigger() {
        const trigger = $(`
            <i class="settings-icon js-BubbleBox-Call ui-BubbleBox-Call icon-settings-size_2-color_lightgrey shift-margin_4-right"></i>
        `);

        const modal = new ModerationModal(this.getModel());
        const showModal = event => {
            event.stopPropagation();
            modal.init(trigger.get(0));
        };

        trigger.on(
            'mouseover',
            showModal.bind(this)
        );

        return trigger;
    }
    buildModerationDeleteWidgetTrigger() {
        const model = this.getModel();
        const trigger = $(`
            <i class="comment-delete__moderation 
                      js-BubbleBox-Call
                      ui-BubbleBox-Call
                      icon-cross-size_2-color_lightgrey"
               data-id="${model.get('id')}"
            ></i>
        `);

        const modal = new BanModal(model);
        const captureDeleteMouseover = event => {
            event.stopPropagation();
            if (model.get('isDeleted')) {
                modal.init(trigger.get(0));
            }
        };

        const captureDeleteClick = event => {
            event.stopPropagation();
            if (!model.get('isDeleted')) {
                document.dispatchEvent(
                    new CustomEvent('DeleteComment', {
                        detail: {
                            id: model.get('id'),
                            isDeleted: model.get('isDeleted'),
                        },
                    })
                );
            }
        };

        trigger.on(
            'click',
            captureDeleteClick.bind(this)
        );
        trigger.on(
            'mouseover',
            captureDeleteMouseover.bind(this)
        );

        return trigger;
    }
    render() {
        const activityDetails = this.getModel().get('User').get('activityDetails');
        if (!activityDetails) {
            return;
        }

        this.rootEl.find(elements.lastActivity).html(`
            Ostatnia aktywność: ${moment(
                activityDetails.lastActivity
            ).fromNow()}`
        );

        this.rootEl.find(elements.lastComment).html(`
            <a href="${activityDetails.lastComment.url}">
                Ostatni komentarz: ${moment(
                    activityDetails.lastComment.date
                ).fromNow()}
            </a>
        `);

        this.rootEl.find(elements.showAll).html(`
            <a href="${activityDetails.commentsSummaryUrl}">
                    Pokaż wszystkie (${activityDetails.commentsCount})
            </a>
        `);

        const replyTrigger = this.buildReplyTrigger();
        this.rootEl.prepend(replyTrigger);

        const moderationTrigger = !CommentsService.isShoutboxMode() ?
                                 this.buildModerationWidgetTrigger() : null;
        const deleteTrigger = this.buildModerationDeleteWidgetTrigger();

        this.rootEl.append([moderationTrigger, deleteTrigger]);
    }
}



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/comments/comment-user-info-view.js